// CP850 mapping: Unicode Consortium / Microsoft, table version 2.00.
// https://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/PC/CP850.TXT
const upper=[
 0x00c7,0x00fc,0x00e9,0x00e2,0x00e4,0x00e0,0x00e5,0x00e7,0x00ea,0x00eb,0x00e8,0x00ef,0x00ee,0x00ec,0x00c4,0x00c5,0x00c9,0x00e6,0x00c6,0x00f4,0x00f6,0x00f2,0x00fb,0x00f9,0x00ff,0x00d6,0x00dc,0x00f8,0x00a3,0x00d8,0x00d7,0x0192,0x00e1,0x00ed,0x00f3,0x00fa,0x00f1,0x00d1,0x00aa,0x00ba,0x00bf,0x00ae,0x00ac,0x00bd,0x00bc,0x00a1,0x00ab,0x00bb,0x2591,0x2592,0x2593,0x2502,0x2524,0x00c1,0x00c2,0x00c0,0x00a9,0x2563,0x2551,0x2557,0x255d,0x00a2,0x00a5,0x2510,0x2514,0x2534,0x252c,0x251c,0x2500,0x253c,0x00e3,0x00c3,0x255a,0x2554,0x2569,0x2566,0x2560,0x2550,0x256c,0x00a4,0x00f0,0x00d0,0x00ca,0x00cb,0x00c8,0x0131,0x00cd,0x00ce,0x00cf,0x2518,0x250c,0x2588,0x2584,0x00a6,0x00cc,0x2580,0x00d3,0x00df,0x00d4,0x00d2,0x00f5,0x00d5,0x00b5,0x00fe,0x00de,0x00da,0x00db,0x00d9,0x00fd,0x00dd,0x00af,0x00b4,0x00ad,0x00b1,0x2017,0x00be,0x00b6,0x00a7,0x00f7,0x00b8,0x00b0,0x00a8,0x00b7,0x00b9,0x00b3,0x00b2,0x25a0,0x00a0
];
export function decodeCp850(bytes:Uint8Array):string {
 const chunks:string[]=[];
 for(let offset=0;offset<bytes.length;offset+=8192){
  const end=Math.min(offset+8192,bytes.length);const codes:number[]=[];
  for(let index=offset;index<end;index++){const byte=bytes[index];codes.push(byte<128 ? byte : upper[byte-128]);}
  chunks.push(String.fromCharCode(...codes));
 }
 return chunks.join("");
}
export function decodeBc3Bytes(buffer:ArrayBuffer,requested="auto"):{text:string;encoding:string} {
 if(buffer.byteLength<1 || buffer.byteLength>8*1024*1024)throw new Error("Escolha um ficheiro BC3 até 8 MB.");
 const bytes=new Uint8Array(buffer);
 const hasBom=bytes[0]===0xef && bytes[1]===0xbb && bytes[2]===0xbf;
 const headerText=new TextDecoder("windows-1252").decode(bytes);
 const header=headerText.split("~").find(record=>/^V\s*\|/.test(record.trim()));
 const declared=header?.split("|")[5]?.trim().toUpperCase() || "850";
 let encoding=requested;
 if(encoding==="auto"){
  if(hasBom || ["UTF-8","UTF8","65001"].includes(declared))encoding="utf-8";
  else if(["ANSI","1252","WINDOWS-1252"].includes(declared))encoding="windows-1252";
  else if(["850","CP850","IBM850"].includes(declared))encoding="ibm850";
  else throw new Error("Codificação declarada "+declared+" não suportada. Confirme a codificação do ficheiro.");
 }
 if(!["utf-8","windows-1252","ibm850"].includes(encoding))throw new Error("Codificação não suportada.");
 const text=encoding==="ibm850" ? decodeCp850(bytes) : new TextDecoder(encoding,{fatal:true}).decode(bytes);
 return {text,encoding};
}
